/**
 * Color utility functions for theme management
 */

/**
 * Convert HSL color to hex format
 * @param {string} hsl - HSL color string (e.g., "hsl(266, 50%, 50%)")
 * @returns {string} Hex color string
 */
export const hslToHex = (hsl) => {
  // If it's already a hex color, return it
  if (hsl.startsWith('#')) {
    return hsl;
  }

  // Parse HSL values
  const match = hsl.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
  if (!match) {
    console.warn(`Invalid HSL color: ${hsl}`);
    return hsl;
  }

  const h = parseInt(match[1]);
  const s = parseInt(match[2]) / 100;
  const l = parseInt(match[3]) / 100;

  // Convert HSL to RGB
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;

  let r = 0, g = 0, b = 0;

  if (h >= 0 && h < 60) {
    r = c; g = x; b = 0;
  } else if (h >= 60 && h < 120) {
    r = x; g = c; b = 0;
  } else if (h >= 120 && h < 180) {
    r = 0; g = c; b = x;
  } else if (h >= 180 && h < 240) {
    r = 0; g = x; b = c;
  } else if (h >= 240 && h < 300) {
    r = x; g = 0; b = c;
  } else if (h >= 300 && h < 360) {
    r = c; g = 0; b = x;
  }

  // Convert to 8-bit RGB values
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  // Convert to hex
  const toHex = (n) => n.toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

/**
 * Add opacity to a color
 * @param {string} color - Color in hex or HSL format
 * @param {number} opacity - Opacity value (0-100)
 * @returns {string} Color with opacity
 */
export const addOpacity = (color, opacity) => {
  const hex = hslToHex(color);
  const opacityHex = Math.round((opacity / 100) * 255).toString(16).padStart(2, '0');
  return `${hex}${opacityHex}`;
};